<template>
    <Button class="ButtonIcon" v-bind="$attrs" :to="to" :href="href" @click="$emit('click')">
        <div class="inner">
            <Icon :name="icon"/>
            <slot></slot>
        </div>
    </Button>
</template>

<script>
export default {
    name: 'ButtonIcon',
    inheritAttrs: false,

    props: {
        icon: { type: String, required: true },
        to: { type: String, default: '' },
        href: { type: String, default: '' },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.ButtonIcon {
    .inner {
        display: flex;
        align-items: center;
    }

    .Icon {
        margin-right: 10px;
    }
}
</style>
